/* Protees Noir — mobile menu (loads its content on first open) */
(function () {
  'use strict';
  if (window.NoirMenu) return;
  var ROOT = ((window.NoirConfig || {}).root || '/').replace(/\/?$/, '/');
  var el = null, panel = null, loading = null, isOpen = false, last = null;

  function build() {
    if (el) return;
    el = document.createElement('div');
    el.className = 'nm'; el.id = 'NoirMenu'; el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<div class="nm-dim" data-nm-close></div><div class="nm-panel" role="dialog" aria-modal="true" aria-label="Menu" tabindex="-1"><div class="nm-load"><i></i><i></i><i></i><i></i><i></i><i></i></div></div>';
    document.body.appendChild(el);
    panel = el.querySelector('.nm-panel');
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-nm-close]')) { close(); return; }
      var mb = e.target.closest('[data-nm-mega-btn]');
      if (mb) { var m = mb.closest('[data-nm-mega]'), on = !m.classList.contains('is-open'); m.classList.toggle('is-open', on); mb.setAttribute('aria-expanded', on ? 'true' : 'false'); return; }
      var t = e.target.closest('[data-nm-tab]');
      if (t) select(t.getAttribute('data-nm-tab'));
    });
  }
  function load() {
    build();
    if (loading) return loading;
    loading = fetch(ROOT + '?section_id=noir-menu', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('menu'); return r.text(); })
      .then(function (h) {
        var d = document.createElement('div'); d.innerHTML = h;
        var c = d.querySelector('[data-nm-content]');
        if (!c) throw new Error('menu');
        panel.innerHTML = ''; panel.appendChild(c);
        var on = panel.querySelector('[data-nm-tab][aria-selected="true"]');
        if (on) select(on.getAttribute('data-nm-tab'));
      })
      .catch(function () { loading = null; });
    return loading;
  }
  function select(id) {
    if (!panel) return;
    var tabs = panel.querySelectorAll('[data-nm-tab]'), cur = null;
    Array.prototype.forEach.call(tabs, function (t) { var on = t.getAttribute('data-nm-tab') === String(id); t.setAttribute('aria-selected', on ? 'true' : 'false'); if (on) cur = t; });
    Array.prototype.forEach.call(panel.querySelectorAll('[data-nm-pane]'), function (p) {
      var on = p.getAttribute('data-nm-pane') === String(id);
      if (on && p.hidden) { p.hidden = false; Array.prototype.forEach.call(p.querySelectorAll('.nm-row'), function (r) { r.style.animation = 'none'; void r.offsetWidth; r.style.animation = ''; }); }
      else if (!on) p.hidden = true;
    });
    var ind = panel.querySelector('.nm-ind');
    if (ind && cur) { ind.style.width = cur.offsetWidth + 'px'; ind.style.transform = 'translateX(' + cur.offsetLeft + 'px)'; }
  }
  function open() {
    build(); load();
    if (isOpen) return;
    isOpen = true; last = document.activeElement;
    document.documentElement.classList.add('nm-lock');
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    setTimeout(function () { panel.focus({ preventScroll: true }); var on = panel.querySelector('[data-nm-tab][aria-selected="true"]'); if (on) select(on.getAttribute('data-nm-tab')); }, 80);
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    document.documentElement.classList.remove('nm-lock');
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    if (last && last.focus) last.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.js-drawer-open-nav');
    if (!b) return;
    e.preventDefault(); e.stopImmediatePropagation();
    open();
  }, true);
  ['touchstart', 'mouseenter', 'focusin'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { if (e.target.closest && e.target.closest('.js-drawer-open-nav')) load(); }, { passive: true, capture: true });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) close(); });
  window.NoirMenu = { open: open, close: close };
})();
/* Protees Noir — desktop menu: Beyond Active Wear flyout */
(function () {
  'use strict';
  if (window.NoirBeyondFly) return;
  window.NoirBeyondFly = true;
  var ROOT = ((window.NoirConfig || {}).root || '/').replace(/\/?$/, '/');
  var ITEMS = [
    ['Beyond Half Sleeves', 'beyond-half-sleeves'],
    ['Beyond Full Sleeves', 'beyond-full-sleeves'],
    ['Hoodies &amp; Sweatshirts', 'beyond-hoodies-amp-sweatshirts'],
    ['Bottoms', 'super-bottoms']
  ];
  var CSS = '' +
    '.site-header .nn-beyond{position:relative}' +
    '.site-header .nn-beyond>.site-nav__dropdown-link .nn-chev{width:9px;height:9px;flex:none;transition:transform .3s}' +
    '.site-header .nn-beyond:hover>.site-nav__dropdown-link .nn-chev{transform:translateX(3px)}' +
    '.site-header .nn-tag{margin-left:8px;padding:3px 6px;border-radius:5px;background:#d0232b;color:#fff;font-size:8.5px;letter-spacing:.12em;vertical-align:1px}' +
    '.site-header .nn-fly{position:absolute;left:calc(100% + 18px);top:-8px;z-index:5;width:290px;margin:0;padding:10px;list-style:none;background:#fff;border-radius:16px;box-shadow:0 22px 60px rgba(0,0,0,.35),0 0 0 1px rgba(0,0,0,.05);opacity:0;visibility:hidden;transform:translateX(10px);transition:opacity .25s,visibility .25s,transform .35s cubic-bezier(.2,.8,.2,1);text-align:left}' +
    '.site-header .nn-fly:before{content:"";position:absolute;top:0;bottom:0;left:-24px;width:24px}' +
    '.site-header .nn-beyond:hover>.nn-fly,.site-header .nn-beyond:focus-within>.nn-fly{opacity:1;visibility:visible;transform:none}' +
    '.site-header .nn-fly li{margin:0;padding:0;list-style:none}' +
    '.site-header .nn-beyond:hover>.nn-fly>li{animation:nddItem .4s cubic-bezier(.2,.8,.2,1) both;animation-delay:calc(var(--i,0) * .045s)}' +
    '.site-header .nn-fly__head{padding:8px 10px 10px;font-size:10px;font-weight:800;letter-spacing:.24em;color:#d0232b;text-transform:uppercase}' +
    '.site-header .nn-fly__a{display:flex;align-items:center;gap:12px;padding:7px 8px;border-radius:12px;background:transparent!important;color:#0a0a0a!important;font-size:12px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;text-decoration:none;transition:background .25s,color .25s}' +
    '.site-header .nn-fly__a:hover{background:#f5f3f2!important;color:#d0232b!important}' +
    '.site-header .nn-fly__img{width:46px;height:46px;border-radius:10px;background:#f1f1ef center/cover no-repeat;flex:none;transition:transform .35s cubic-bezier(.2,.8,.2,1)}' +
    '.site-header .nn-fly__a:hover .nn-fly__img{transform:scale(1.08)}' +
    '.site-header .nn-fly__go{margin-left:auto;opacity:0;transform:translateX(-6px);transition:opacity .25s,transform .3s}' +
    '.site-header .nn-fly__a:hover .nn-fly__go{opacity:1;transform:none}' +
    '.site-header .nn-fly .nn-fly__all{display:flex;align-items:center;justify-content:center;gap:8px;margin-top:8px;padding:12px;border-radius:999px;background:#0a0a0a!important;color:#fff!important;font-size:11px;font-weight:800;letter-spacing:.14em;text-transform:uppercase;text-decoration:none;transition:background .25s}' +
    '.site-header .nn-fly .nn-fly__all:hover{background:#d0232b!important}' +
    '@media (max-width:768px){.site-header .nn-fly{display:none}}';
  var ARROW = '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 6h8M6.5 2.5 10 6l-3.5 3.5" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';

  function loadImgs(ul) {
    if (ul.getAttribute('data-loaded')) return;
    ul.setAttribute('data-loaded', '1');
    var spans = ul.querySelectorAll('[data-h]');
    Array.prototype.forEach.call(spans, function (s) {
      fetch(ROOT + 'collections/' + s.getAttribute('data-h') + '/products.json?limit=1')
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var p = j && j.products && j.products[0];
          var src = p && p.images && p.images[0] && p.images[0].src;
          if (src) s.style.backgroundImage = 'url("' + src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120")';
        })['catch'](function () {});
    });
  }

  function enhance(a) {
    var li = a.parentNode;
    if (!li || li.classList.contains('nn-beyond')) return;
    li.classList.add('nn-beyond');
    a.href = ROOT + 'collections/beyond-active';
    a.setAttribute('aria-haspopup', 'true');
    a.innerHTML = '<span>BEYOND ACTIVE WEAR</span><svg class="nn-chev" viewBox="0 0 10 10" aria-hidden="true"><path d="M3 1l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';
    var ul = document.createElement('ul');
    ul.className = 'nn-fly';
    var html = '<li class="nn-fly__head" style="--i:0">Beyond Active Wear</li>';
    ITEMS.forEach(function (it, i) {
      html += '<li style="--i:' + (i + 1) + '"><a class="nn-fly__a" href="' + ROOT + 'collections/' + it[1] + '">' +
        '<span class="nn-fly__img" data-h="' + it[1] + '"></span><span>' + it[0] + '</span><span class="nn-fly__go">' + ARROW + '</span></a></li>';
    });
    html += '<li style="--i:' + (ITEMS.length + 1) + '"><a class="nn-fly__all" href="' + ROOT + 'collections/beyond-active">Shop all Beyond ' + ARROW + '</a></li>';
    ul.innerHTML = html;
    li.appendChild(ul);
    li.addEventListener('mouseenter', function () { loadImgs(ul); });
    li.addEventListener('focusin', function () { loadImgs(ul); });
  }

  function init() {
    if (!document.getElementById('nn-fly-css')) {
      var st = document.createElement('style');
      st.id = 'nn-fly-css';
      st.textContent = CSS;
      document.head.appendChild(st);
    }
    var links = document.querySelectorAll('.site-header .site-nav__dropdown .site-nav__dropdown-link');
    Array.prototype.forEach.call(links, function (a) {
      if (a.closest('.nn-fly')) return;
      if (/^beyond active/i.test((a.textContent || '').trim())) enhance(a);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
